<template>
  <div class="navbar navbar-expand-md bg-dark navbar-dark sticky-top">
    <a href="/" class="h1 text-secondary">
      todo.cool 🎉
    </a>
    <button class="navbar-toggler" type="button" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon" data-toggle="collapse" data-target="#navbar-collapse"></span>
    </button>
    <div class="collapse navbar-collapse flex-column" id="navbar-collapse">
      <ul class="navbar-nav d-lg-block">
        <li class="nav-item">
          <router-link :to="{ name: 'inbox' }" class="nav-link" data-toggle="collapse" data-target="#navbar-collapse">
            Inbox
          </router-link>
        </li>
        <li class="nav-item" v-for="featuredProjectArea in featuredProjectAreas">
          <router-link :to="{ name: 'category', params: { id: featuredProjectArea.id } }" class="nav-link" data-toggle="collapse" data-target="#navbar-collapse">
            {{ featuredProjectArea.name }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'all_projects' }" class="nav-link" data-toggle="collapse" data-target="#navbar-collapse">
            {{ $t("projects.parent") }}
          </router-link>
        </li>
        <hr class="nav-hr" />
        <li class="nav-item">
          <router-link :class="{ disabled: isDisabled() }" :to="{ name: 'archived_projects' }" class="nav-link font-italic text-muted" data-toggle="collapse" data-target="#navbar-collapse">
            {{ $t("projects.parent")}} Archive
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'journal' }" class="nav-link font-italic text-muted" data-toggle="collapse" data-target="#navbar-collapse">
            Journal
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'trash' }" class="nav-link font-italic text-muted" data-toggle="collapse" data-target="#navbar-collapse">
            Trash
          </router-link>
        </li>
        <hr class="nav-hr" />
        <li class="nav-item">
          <a href="#" class="nav-link font-italic text-muted d-flex align-items-center" @click.prevent="archiveExpanded = !archiveExpanded" :aria-expanded="archiveExpanded.toString()" aria-controls="archive-submenu">
            <span class="mr-2" :style="{ display: 'inline-block', transition: 'transform 0.15s ease-in-out', fontSize: '1.25em', lineHeight: '1', transform: archiveExpanded ? 'rotate(90deg)' : 'none' }">▸</span>
            Archive
          </a>
          <ul v-show="archiveExpanded" id="archive-submenu" class="navbar-nav" style="padding-left: 1rem;">
            <li v-if="this.gmail" class="nav-item">
              <router-link :to="{ name: 'gmail' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                Gmail
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'today' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                {{ $t("tier1.today.name") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'project_essentials' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                {{ $t("tier1.project_essentials.name") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'waiting' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                {{ $t("tier1.waiting.name") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'someday' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                {{ $t("tier1.someday.name") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'all_contacts' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                Assistants
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'all_tags' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                {{ $t("tags.plural") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'calendar' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                {{ $t("tier1.calendar.name") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'in_process' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                {{ $t("tier1.in_process.name") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'archived_tags' }" class="nav-link text-muted" data-toggle="collapse" data-target="#navbar-collapse">
                {{ $t("tags.singular")}} Archive
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
export default {
  props: ['gmail'],
  data() {
    return {
      archiveExpanded: false
    }
  },
  computed: {
    archivedProjects: {
      get() {
        return this.$store.state.archived_projects
      }
    },
    featuredProjectAreas: {
      get() {
        return this.$store.state.project_areas.filter(area => area.featured)
      }
    }
  },
  methods: {
    isDisabled(){
      return this.archivedProjects.length == 0
    }
  }
}

</script>
